// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qk_a bhl_sw bhl_kx bhl_ky","PostDetailRight__brandDaysPosts":"qk_b bhl_sw bhl_kx bhl_ky"};